import { createStyles, CSSProperties, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const wrapText: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    // White rounded section card (Overview redesign). Explicit px values —
    // theme.spacing() output varies (number vs "8px") across theme setups.
    card: {
      width: '100%',
      // Padding must count inside the 100% width, or the card overflows the
      // viewport by its own padding.
      boxSizing: 'border-box',
      backgroundColor: theme.palette.white,
      borderRadius: 16,
      border: '1px solid #EAECF0',
      boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)',
      padding: '8px 24px 24px',
      marginBottom: 24,
    },
    item: {
      color: theme.palette.black,
      cursor: 'pointer',
      padding: '16px 0',
      marginBottom: 8,
      width: '100%',
    },
    disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
    tooltipContainer: {
      width: '100%',
      display: 'block',
    },
    itemText: {
      ...wrapText,
      textTransform: 'capitalize',

      '& .MuiTypography-body1': {
        fontSize: '20px',
        fontWeight: 700,
        color: theme.palette.black,
      },
    },

    itemIcon: {
      color: theme.palette.white,
      marginLeft: theme.spacing(2),
    },
  })
);

export default useStyles;
